<script setup lang="ts">
import WarningIcon from '@/assets/icons/WarningIcon.vue';

defineProps<{
  label: string;
  noBackground?: boolean;
  compact?: boolean;
}>();
</script>

<template>
  <div
    :class="[
      'flex rounded-sm py-sm',
      compact ? 'gap-sm items-center' : 'gap-md px-md',
      !noBackground && 'bg-surface-warning/10',
    ]"
  >
    <div
      :class="[
        'rounded-full size-icon',
        'flex items-center justify-center shrink-0',
        !noBackground && 'bg-surface-warning',
      ]"
    >
      <WarningIcon :class="['size-icon-xs', noBackground ? 'text-warning' : 'text-on-tint']" />
    </div>
    <span class="text-warning">{{ label }}</span>
  </div>
</template>
